module.exports = __webpack_public_path__ + "img/lkz_ico_46.bd339d11.svg";